import { applyTimezone, parseDate } from '../helpers/date';
import { DjangoProductSettings, ProductSettings } from './product_settings.model';

export enum PRODUCT_TYPE {
  PAYROLL_LOAN = 'PAYROLL_LOAN',
  PERSONAL_LOAN = 'PERSONAL_LOAN',
  PAYCHECK_ADVANCE = 'PAYCHECK_ADVANCE',
}

export enum PRODUCT_TYPE_TRANSLATE {
  PAYROLL_LOAN = 'Empréstimo consignado',
  PERSONAL_LOAN = 'Empréstimo pessoal',
  PAYCHECK_ADVANCE = 'Adiantamento',
}

export enum PRODUCT_OPERATION_TYPE {
  NEW_LOAN = 'NEW_LOAN',
  REFINANCE = 'REFINANCE',
  DEBT_TRANSFER = 'DEBT_TRANSFER',
  REFINANCE_AND_DEBT_TRANSFER = 'REFINANCE_AND_DEBT_TRANSFER',
  PORTABILITY = 'PORTABILITY',
}

export enum PRODUCT_OPERATION_TYPE_TRANSLATE {
  NEW_LOAN = 'Empréstimo',
  REFINANCE = 'Refinanciamento',
  DEBT_TRANSFER = 'Troca de dívida',
  REFINANCE_AND_DEBT_TRANSFER = 'Refi. e Troca de dívida',
  PORTABILITY = 'Portabilidade',
}

export class Product {
  id: string;
  productType: PRODUCT_TYPE;
  operationType: PRODUCT_OPERATION_TYPE;
  name: string;
  description: string;
  isEnabled: boolean;
  productSettings: ProductSettings;
  createdBy: Date;
  modifiedBy: Date;

  constructor(data: string | Product | DjangoProduct = {}) {
    if (typeof data === 'string') {
      bindConstructorDataToInstance(this, { id: data });
    } else {
      bindConstructorDataToInstance(this, data);
    }
  }
}

export function parseProduct(data: Product | DjangoProduct = {}) {
  if (data) {
    return new Product(data);
  } else {
    return undefined;
  }
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoProduct {
  id?: string;
  product_type?: PRODUCT_TYPE;
  operation_type?: PRODUCT_OPERATION_TYPE;
  name?: string;
  description?: string;
  is_enabled?: boolean;
  product_settings?: DjangoProductSettings;
  created_by?: Date;
  modified_by?: Date;
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(instance: Product, data: any) {
  const jsData = bindDjangoPropsToJs(data) as Product;
  instance.id = jsData.id;
  instance.name = jsData.name;
  instance.description = jsData.description;
  instance.productType = jsData.productType;
  instance.operationType = jsData.operationType;
  instance.isEnabled = jsData.isEnabled;
  instance.createdBy = applyTimezone(parseDate(jsData.createdBy), 0);
  instance.modifiedBy = applyTimezone(parseDate(jsData.modifiedBy), 0);
  instance.productSettings = jsData.productSettings;
}

function bindDjangoPropsToJs(data: Product | DjangoProduct) {
  const djangoData = data as DjangoProduct;
  const jsData = data as Product;
  return {
    id: djangoData.id || jsData.id,
    productType: djangoData.product_type || jsData.productType,
    operationType: djangoData.operation_type || jsData.operationType,
    name: djangoData.name || jsData.name,
    description: djangoData.description || jsData.description,
    isEnabled: djangoData.is_enabled || jsData.isEnabled,
    createdBy: djangoData.created_by || jsData.createdBy,
    modifiedBy: djangoData.modified_by || jsData.modifiedBy,
    productSettings: djangoData.product_settings
      ? new ProductSettings(djangoData.product_settings)
      : new ProductSettings(jsData.productSettings),
  } as Product;
}
